/*
 * @Author: libo 
 * @Date: 2020-11-18 21:11:26 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-06-16 17:10:46
 */

<!--表具激活界面-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" :colon="false" layout="vertical">
        <div >
          <a-divider orientation="left">
            {{ $t('用户信息') }}
          </a-divider>
          <detail-list>
            <!-- <detail-list-item term="区域名称">{{model.userAreaName}}</detail-list-item> -->
            <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('表类型')">{{model.meterTypeName}}({{model.meterType}})</detail-list-item>
            <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
            <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
            <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
            <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
            <detail-list-item :term="$t('身份证号')">{{model.userIdNumber}}</detail-list-item>
            <detail-list-item :term="$t('户型')">{{model.userHouseholdName}}</detail-list-item>
            <detail-list-item :term="$t('用户类型')">{{model.userTypeName}}</detail-list-item>
            <detail-list-item :term="$t('营收编号')">{{model.userPayId}}</detail-list-item>
            <detail-list-item :term="$t('身份类型')">{{model.userIdType== 1?$t('自然人'): $t('企业')}}</detail-list-item>
            <detail-list-item :term="$t('小区或村庄名')">{{model.userCommName}}</detail-list-item>
            <detail-list-item :term="$t('是否允许缴费')">{{model.userPayState == 1?$t('允许'): $t('不允许')}}</detail-list-item>
            <detail-list-item :term="$t('优惠信息')">{{model.userFreeinfo_dictText ? $t(model.userFreeinfo_dictText) : model.userFreeinfo_dictText}}</detail-list-item>
            <detail-list-item :term="$t('用户地址')" :itemCol="1">{{model.userAreaName&&model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</detail-list-item>
          </detail-list>
          <a-divider orientation="left">
            {{ $t('表具最新信息') }}
          </a-divider>
          <detail-list>
            <detail-list-item :term="$t('最后上报日期')">{{userDetailInfo.meterUpDataTime}}</detail-list-item>
            <detail-list-item :term="$t('最后上报读数(m³)')">{{userDetailInfo.meterTotalUse}}</detail-list-item>
          </detail-list>
        </div>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-model-item :label="$t('开始计费读数')">
              <a-input v-decorator="['userMeterStartNum',validatorRules.userMeterStartNum]"  :placeholder="$t('请输表开始计费读数')" suffix="m³" style="width:80%"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('是否整数计费')">
              <j-dict-select-tag v-decorator="['isIntegerBilling', {initialValue: 0}]" :triggerChange="true" :showSearch="false" :placeholder="$t('请选择是否整数计费')" dictCode="yn" style="width:100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('价格名称')">
              <a-select v-decorator="['userPriceCode',validatorRules.userPriceCode]" :placeholder="$t('请选择用户价格名称')"
                :disabled="this.model.userState==1" @change="changePrice"
                :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id">
                  <a-tooltip>
                    <template slot="title">
                      {{ $t('单价:') }}{{data.wtTotalPrice/100}}{{ $t('元') }}
                    </template>
                    {{data.wtName}}
                  </a-tooltip>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col v-if="!isEmptyPriceInfo">
            <detail-list :span="24">
              <detail-list-item :term="$t('价格编码')">{{priceInfo.wtCode}}</detail-list-item>
              <detail-list-item :term="$t('价格名称')">{{priceInfo.wtName}}</detail-list-item>
              <detail-list-item :term="$t('单价总计')">{{priceInfo.wtTotalPrice/100}}({{ $t('元/m³') }})</detail-list-item>
              <detail-list-item :term="$t('计费类型')">{{priceInfo.wtFeeType_dictText ? $t(priceInfo.wtFeeType_dictText) : priceInfo.wtFeeType_dictText}}</detail-list-item>
              <detail-list-item :term="$t('阶梯数量')">{{priceInfo.wtStepNum}}</detail-list-item>
              <detail-list-item :term="$t('附加费总计')">{{priceInfo.wtTotalChargePrice?priceInfo.wtTotalChargePrice/100:''}}({{ $t('元/m³') }})</detail-list-item>
              <template v-if="priceInfo.wtStepNum>1">
                <detail-list-item :term="$t('阶梯计费方式')">{{priceInfo.wtStepCalWay_dictText ? $t(priceInfo.wtStepCalWay_dictText) : priceInfo.wtStepCalWay_dictText}}</detail-list-item>
                <detail-list-item :term="$t('阶梯起始日期')">{{priceInfo.wtBeginDate}}</detail-list-item>

              </template>
              <template v-if="priceInfo.wtStepNum>1">
                <detail-list-item :term="$t('一阶水量上限')">{{priceInfo.wtStep1Top}}(m³)</detail-list-item>
                <detail-list-item :term="$t('一阶单价')">{{priceInfo.wtStep1Price/100}}({{ $t('元/m³') }})</detail-list-item>
              </template>
              <template v-if="priceInfo.wtStepNum>=2">
                <detail-list-item :term="$t('二阶水量上限')">{{priceInfo.wtStep2Top}}(m³)</detail-list-item>
                <detail-list-item :term="$t('二阶单价')">{{priceInfo.wtStep2Price/100}}({{ $t('元/m³') }})</detail-list-item>
              </template>
              <template v-if="priceInfo.wtStepNum>=3">
                <detail-list-item :term="$t('三阶水量上限')">{{priceInfo.wtStep3Top}}(m³)</detail-list-item>
                <detail-list-item :term="$t('三阶单价')">{{priceInfo.wtStep3Price/100}}({{ $t('元/m³') }})</detail-list-item>
              </template>
              <template v-if="priceInfo.wtStepNum>=4">
                <detail-list-item :term="$t('四阶水量上限')">{{priceInfo.wtStep4Top}}(m³)</detail-list-item>
                <detail-list-item :term="$t('四阶单价')">{{priceInfo.wtStep4Price/100}}({{ $t('元/m³') }})</detail-list-item>
              </template>
              <template v-if="priceInfo.wtStepNum>=5">
                <detail-list-item :term="$t('五阶水量上限')">{{priceInfo.wtStep5Top}}(m³)</detail-list-item>
                <detail-list-item :term="$t('五阶单价')">{{priceInfo.wtStep5Price/100}}({{ $t('元/m³') }})</detail-list-item>
              </template>
              <detail-list-item :term="$t('报警金额')">{{priceInfo.wtAlarmMoney}}({{ $t('元') }})</detail-list-item>
              <detail-list-item :term="$t('最大透支金额')">{{priceInfo.wtOverdrafTmoney}}({{ $t('元') }})</detail-list-item>
              <detail-list-item :term="$t('单次最大购买金额')">{{priceInfo.wtMaxBuyOnce}}({{ $t('元') }})</detail-list-item>
              <detail-list-item :term="$t('最大囤积金额')">{{priceInfo.wtMaxHording}}({{ $t('元') }})</detail-list-item>
              <detail-list-item :term="$t('磁干扰关阀')">{{priceInfo.wtCloseValveCigaorao== 1?$t('开启'): $t('不开启')}}</detail-list-item>
              <detail-list-item :term="$t('透支关阀')">{{priceInfo.wtCloseValveOverdraf== 1?$t('开启'): $t('不开启')}}</detail-list-item>
              <detail-list-item :term="$t('欠压关阀')">{{priceInfo.wtCloseValveQianya== 1?$t('开启'): $t('不开启')}}</detail-list-item>
              <detail-list-item :term="$t('报警关阀')">{{priceInfo.wtCloseValveAlarm== 1?$t('开启'): $t('不开启')}}</detail-list-item>
          </detail-list>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import {listSize } from '@/utils/util'
  import {isEmptyObject} from '@/utils/validate'
  import { getAction,httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterActivateForm',
    components: {
      JFormContainer,
      DetailList,
      DetailListItem
    },
    data () {
      return {
        treeData:[],
        phoneWarning:'',
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {},
        confirmLoading: false,
        form: this.$form.createForm(this),
        userPriceCode:[], // 价格编码
        url: {
          list: "/jeecg-charge/meter/meterUserinfo/list",
          doActivate: "/jeecg-charge/meter/userPay/doActivate",
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",
          queryUserDetailInfoById:'/jeecg-charge/meter/meterUserinfo/queryUserDetailInfoById', //用户详情
        },
        priceInfo: {},
        userDetailInfo: {}
      }
    },
    computed: {
      // i18n：标题/校验消息使用 computed 以响应语言切换
      title () {
        return this.$t('操作')
      },
      validatorRules() {
        return {
          userMeterStartNum: {
            rules: [
              {required: true, message: this.$t('请输入表开始计费读数!')},
              {required: false,pattern: /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,message: this.$t('表开始计费读数最多保留两位小数')}
            ]
          },
          isIntegerBilling: {
            rules:[
              {required:true, message:this.$t('请选择是否整数计费！')},
            ]
          },
          userPriceCode:{  //价格名称
            rules:[
              {required:true, message:this.$t('请选择价格编码！')},
            ]
          },
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      isEmptyPriceInfo() {
        return isEmptyObject(this.priceInfo)
      }
    },
    created () {
    },
    methods: {
      add (depart) {
        if(depart){
          this.seen = false;
        }else{
          this.seen = true;
        }
        this.edit(depart);
      },
      edit (record) {
        this.priceInfo = {};
        this.form.resetFields();
        this.model = Object.assign({},record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'userAreaName','meterId','meterTypeName','userAddr','userMeterAddr','userId','userName','userPhone','userIdNumber','userHouseholdName','userTypeName','userPayId','userIdType','userCommName','userPayState','userFreeinfo'))
        });
        this.queryUserPriceCode();
        this.queryUserDetailInfo();
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.doActivate;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            formData.userMeterStartNum = parseFloat(formData.userMeterStartNum)
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                if(res.code == 0) {
                  that.$message.success(res.message);
                  setTimeout(() => {
                  that.$emit('ok',that.model);
                },400)
                }else{
                  that.$message.warning(res.message);
                }
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      queryUserPriceCode() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.statusDisable = 0;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
          }
        })
      },
      queryUserDetailInfo() {  //用户详情
        let params = {};
        params.id = this.model.id;
        getAction(this.url.queryUserDetailInfoById, params).then((res) => {
          if(res.success){
            this.userDetailInfo = res.result;
          }
          this.loading = false;
        })
      },
      changePrice(value) {
        console.log(value)
        this.priceInfo = {};
        if(value==''||value==undefined) {
          return;
        }
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.id = value;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.priceInfo = res.result.records[0];
            console.log(this.priceInfo);
          }
        })
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
    line-height: normal;
}
</style>